import React, { useState, useEffect } from 'react'
import { useHistory, Link } from 'react-router-dom';
import Header from '../../common/header'
import Footer from '../../common/footer'
import SvgIcon from '../../common/svg-icon/svg-icon'
import { Breadcrumb, Button, Dropdown, Input } from 'semantic-ui-react'
import RightSideBar from '../../common/rightsidebar'
import './index.scss'

import CardBg from '../../../assets/images/new-images/weare-bg.jpg';
import EventCard from '../../../assets/images/new-images/event-card.jpg';
import EventBanner from '../../../assets/images/new-images/event-banner.jpg';

import { NewInviteUser } from '../../common/newInviteUser';
import axios from 'axios';
import { BASE_URL } from '../../../config/config';
import { formatIsoMilisecondOnlyTime, formatIsoMilisecondsWithoutTime, getDay, formatIsoMiliseconds, replaceSpaceInName, feedTimeAgo, month_names_short, getTwelveHoursTime, getFormattedDate2 } from '../../../common/helperMethods';
import SEO from '../../../components/seo/SEO';

const EventsListView = () => {
  const [eventsData, seteventData] = useState([]);
  const history = useHistory();

  const sections = [
    { key: 'Home', content: 'Home', link: true, href: '/' },
    { key: 'events', content: 'Events', link: false },
  ]

  /* const dropOptions = [
    { key: '1', value: 'Option1', text: 'Option1' },
    { key: '2', value: 'Option2', text: 'Option2' },
    { key: '3', value: 'Option3', text: 'Option3' },
    { key: '4', value: 'Option4', text: 'Option4' },
    { key: '5', value: 'Option5', text: 'Option5' },
    { key: '6', value: 'Option6', text: 'Option6' },
    { key: '7', value: 'Option7', text: 'Option7' },
  ] */

  useEffect(() => {
    axios.get(`${BASE_URL}/api/events/promotional`, {
      "from": 0,
      "size": 10
    }).then((response) => {
      const { data } = response.data
      data.rows.forEach(item => {
        item.eventStartDate = isNaN(item.startDate) ? item.startDate : getFormattedDate2(+item.startDate);
        item.eventStarTime = (item.startDate) ? getTwelveHoursTime(+item.startDate) : '';
        item.eventStartDay = getDay(+item.startDate);
        item.eventEndDate = isNaN(item.endDate) ? item.endDate : getFormattedDate2(+item.endDate);
        item.eventEndTime = (item.endDate) ? getTwelveHoursTime(+item.endDate) : '';
        item.eventEndDay = getDay(+item.endDate);
        item.EventDate = new Date(parseInt(item.startDate)).getDate()
        item.EventMonth = month_names_short[new Date(parseInt(item.endDate)).getMonth()];
        item.eventStartDate = (item.eventStartDate != 'Invalid Date') ? item.eventStartDate : '';
        item.eventEndDate = (item.eventEndDate != 'Invalid Date') ? item.eventEndDate : '';

        item.eventStarTime = (item.eventStarTime != 'Invalid Date') ? item.eventStarTime : '';
        item.eventEndTime = (item.eventEndTime != 'Invalid Date') ? item.eventEndTime : '';

      })

      seteventData(data.rows)

    }).finally(() => {
      //  setLoading(false)
    })
  }, [])

  const render_slider = (eventdata) => {
    const { image, eventName } = eventdata || {};
    if (image != undefined) {
      if (Array.isArray(image) && image.length > 0) {
        return (
          <img src={image[0]} className='w-100' alt={eventName} title={eventName} onError={({ currentTarget }) => {
            currentTarget.onerror = null;
            currentTarget.src = EventCard;
          }} />
        )
      } else if (!Array.isArray(image)) {
        return (
          <img src={image} alt={eventName} className='w-100' title={eventName} onError={({ currentTarget }) => {
            currentTarget.onerror = null;
            currentTarget.src = EventCard;
          }} />
        )
      } else {
        return (
          <img src={EventCard} alt={eventName} className='w-100' title={eventName} />
        )
      }
    } else {
      return (
        <img src={EventCard} className='w-100' alt={eventName} title={eventName} />
      )
    }
  }

  const event_details = (id, name) => {
    history.push(`/events/${replaceSpaceInName(name)}/${id}`);
  }

  const add_event = () => {
    // history.push(`/addevent`)
    history.push(`/otp-login`)
  }

  const render_address = (event) => {
    const { location, eventLocation } = event || {};
    if (eventLocation) {
      if (!eventLocation.city && !eventLocation.country) {
        return (
          <span>{location}</span>
        )
      }

      return (
        <span>{eventLocation.city} {eventLocation.city && eventLocation.country ? `,  ` : ''} {eventLocation.country ? `  ${eventLocation.country}` : ''} {eventLocation.pincode ? `-  ${eventLocation.pincode}` : ''}</span>
      )
    } else {
      return (
        <span>{location}</span>
      )
    }

  }

  return (
    <>
      <SEO key="events-list-seo"
        robots="index, follow"
        canonicalUrl="/event"
        alternateLink="/event"
        pageType={'event'}
        pageContent={{ eventName: 'Upcoming Events in Advanced Manufacturing', details: 'Stay updated on upcoming events, webinars, and conferences in advanced manufacturing to network and discover new technologies.' }}

      />
      <Header />
      <div className='innerpages-wrapper'>
        <section className='breadcrumb-section'>
          <div className='mappes-container'>
            <Breadcrumb icon={<SvgIcon name='chevron-right' viewbox="0 0 8 14" />} sections={sections} />
          </div>
        </section>
        <section>
          <div className='mappes-container'>
            <div className='innerpages-wrapper-inner locked-post'>
              <div className='innerpages-left-section'>
                <div className='eventspage-banner'>
                  <img className='banner-img' src={EventBanner} alt='' />
                  <div className='eventspage-inner'>
                    <div className='upper-row'>
                      <div>
                        <SvgIcon name='map-outline' viewbox='0 0 20 22' /> Hosting an Expo, Conference, or Webinar?
                      </div>
                      {/* <div className='datetime'>
                        12:34 IST
                      </div> */}
                    </div>
                    <p>Expand Event Reach Across the Entire Industry Value Chain. <br />By positioning your event within our technology ecosystems, it becomes discoverable by manufacturers, and application stakeholders across the full value chain.</p>
                    <div>
                      <Button onClick={() => add_event()}>Create an Event</Button>
                    </div>
                  </div>
                </div>
                <div className='left-fiter-row eventpage-filter-row align-items-start mb-0'>
                  <div className='left-col'>
                    Explore <span>Curated Events</span>
                  </div>
                </div>
                <div className='left-fiter-row eventpage-filter-row align-items-end'>
                  {/*                   <div className='left-col'>
                    <div className='events-sort'>
                      <button>Online Events</button>
                      <button>Offline Events</button>
                      <button>Near me</button>
                    </div>
                  </div> */}
                  {/* <div className='right-col'>
                    <Dropdown icon={<SvgIcon name='chevron-bottom' viewbox="0 0 14 8" />} placeholder='Sort: Popularity' options={dropOptions} />
                    <Dropdown icon={<SvgIcon name='filters' viewbox="0 0 17 17" />} placeholder='Filter' options={dropOptions} />
                  </div> */}
                </div>
                <div className='left-content-row'>
                  <div className='event-list'>
                    {/* {StayConnectedSlides.map(slide => (
                      <div key={slide.id} className='stayconnect-card'>
                        <div className='card-upper'>
                          <div className='date-col'><h3>10</h3><p>June</p></div>
                          <img src={slide.image} alt='' />
                        </div>
                        <div className='card-bottom'>
                          <div className='event-name'>{slide.name}</div>
                          <div className='info-list'>
                            <div className='list-item'><div className='icons'><SvgIcon name='date-icon' viewbox="0 0 18 20" /></div> Wednesday | June 10, 2024 - June 18, 2024</div>
                            <div className='list-item'><div className='icons'><SvgIcon name='time-icon' viewbox="0 0 19 19" /></div> 12:00 PM - 06:00 PM</div>
                            <div className='list-item'><div className='icons'><SvgIcon name='map-icon' viewbox="0 0 16 20" /></div> St. Xavier’s Auditorium, Alberta, Canada</div>
                          </div>
                        </div>
                        <div className='card-action'>
                          <div className='left-action'><Button>Going</Button></div>
                          <div className='right-action'>
                            <Button><SvgIcon name='shares-icon' viewbox="0 0 18 15" /></Button>
                            <Button><SvgIcon name='tag-icon' viewbox="0 0 15 18" /></Button>
                          </div>
                        </div>
                      </div>
                    ))} */}
                    {eventsData.length > 0 && eventsData.map(slide => (
                      <div key={slide.id} className='stayconnect-card cursor-pointer' onClick={() => event_details(slide.id, slide.eventName)}>
                        <div className='card-upper'>
                          <div className='date-col'><h3>{slide.EventDate}</h3><p>{slide.EventMonth}</p></div>
                          {render_slider(slide)}
                        </div>
                        <div className='card-bottom'>
                          <div className='event-name cursor-pointer' onClick={() => event_details(slide.id, slide.eventName)}>{slide.eventName}</div>
                          {/* <div className='event-desc'>{slide.details.substr(0, 200)}</div> */}
                          <div className='info-list'>
                            <div className='list-item'><div className='icons'><SvgIcon name='date-icon' viewbox="0 0 18 20" /></div> {slide.eventStartDay} | {slide.eventStartDate} - {slide.eventEndDate}</div>
                            <div className='list-item'><div className='icons'><SvgIcon name='time-icon' viewbox="0 0 19 19" /></div> {slide.eventStarTime} - {slide.eventEndTime}</div>

                            <div className='list-item'>
                              {slide.eventType == 'online' && (<><div className='icons'><SvgIcon name='video-icon' viewbox='0 0 20.332 13.667' /> </div> Online</>)}
                              {slide.eventType == 'offline' && (<><div className='icons'><SvgIcon name='map-icon' viewbox='0 0 16 20' /> </div>  {render_address(slide)} </>)}

                            </div>
                          </div>
                        </div>
                        <div className='card-action'>
                          <div className='left-action'><Button onClick={() => event_details(slide.id, slide.eventName)}>I'm Attending</Button></div>
                          <div className='right-action'>
                            <Button onClick={() => event_details(slide.id, slide.eventName)}><SvgIcon name='shares-icon' viewbox="0 0 18 15" /></Button>
                            <Button onClick={() => event_details(slide.id, slide.eventName)}><SvgIcon name='tag-icon' viewbox="0 0 15 18" /></Button>
                          </div>
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              </div>
              <RightSideBar show={'post'} industry={''} />
              <div className='no-readable-overlap'></div>
            </div>
          </div>
        </section>
        <section className='mappessubcribe-section'>
          <div className='mappes-container'>
            <div className='mappessubcribe-card'>
              <img className='mappessubcribe-bg' src={CardBg} alt='' />
              <div className='mappessubcribe-row'>
                <h2 className='text-white'>Sign up to create, promote, or plan <br /> an upcoming event in your industry.</h2>
                <NewInviteUser />
              </div>
            </div>
          </div>
        </section>
      </div>
      <Footer />
    </>
  )
}

export default EventsListView